import type { Account, EmployeeForm, EmployeePolicy } from "Utils/types";

export type ReceiveEmployeeFormAction = {
  type: typeof RECEIVE_EMPLOYEE_FORM;
  payload: EmployeeForm;
};
export type ReceiveEmployeePolicyAction = {
  type: typeof RECEIVE_EMPLOYEE_POLICY;
  payload: EmployeePolicy;
};
export type Action = ReceiveEmployeeFormAction | ReceiveEmployeePolicyAction;
export const RECEIVE_ACCOUNT = "EmployeeDashboard/RECEIVE_ACCOUNT";
export const RECEIVE_EMPLOYEE_FORM = "EmployeeDashboard/RECEIVE_EMPLOYEE_FORM";
export const RECEIVE_EMPLOYEE_POLICY = "EmployeeDashboard/RECEIVE_EMPLOYEE_POLICY";
export const receiveAccount = (response: Account) => ({
  type: RECEIVE_ACCOUNT,
  payload: response,
});
export const receiveEmployeeForm = (response: EmployeeForm) => ({
  type: RECEIVE_EMPLOYEE_FORM,
  payload: response,
});
export const receiveEmployeePolicy = (response: EmployeePolicy) => ({
  type: RECEIVE_EMPLOYEE_POLICY,
  payload: response,
});
export const REQUEST_TERMINATE_EMPLOYEE_DEPENDENT = "EmployeeDashboard/REQUEST_TERMINATE_EMPLOYEE_DEPENDENT";
export const requestTerminateEmployeeDependent = (employeeFormId: string, employeeDependentId: string) => ({
  type: REQUEST_TERMINATE_EMPLOYEE_DEPENDENT,
  employeeFormId,
  employeeDependentId,
});
